import { ReportName } from '../../../helpers/ReportHelper';
import Constants from '../../../utils/Constants';
import {
    baseReportsApi,
    GetApiFmByFlidReportsExcelApiArg,
    GetApiFmByFlidReportsExcelApiResponse,
    GetApiFmByFlidReportsJsonApiArg,
    PostApiFmByFlidReportsRequestsApiArg,
    PostApiFmByFlidReportsRequestsApiResponse,
    GetApiFmByFlidReportsAndTokenApiResponse,
    GetApiFmByFlidReportsAndTokenApiArg,
} from './baseReportsApi';

export const reportsApi = baseReportsApi
    .injectEndpoints({
        endpoints: build => ({
            getCommodityUsageReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                GetCommodityUsageReportExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getCommodityHistoryReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                GetCommodityHistoryReportExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getMedicalInventoryReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                GetMedicalInventoryReportExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getCommodityPricingReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                GetCommodityPricingReportExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getMedicalPricingReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                GetMedicalPricingReportExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getEidLotReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                EidLotReportExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getReceiveReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                ReceiveReportExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getRealizerReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                RealizerReportExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getShipCattleReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                ShipCattleReportExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getAsFedReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                AsFedReportExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getFeedByLotReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                FeedByLotExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getPenRiderReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                PenRiderExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getFeedOutOfVarianceReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                FeedOutOfVarianceExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getMoveToCattleReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                MoveToCattleExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getFeedOutOfVarianceReportExcelAsync: build.mutation<
                PostApiFmByFlidReportsRequestsApiResponse,
                FeedOutOfVarianceExcelApiAsyncArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.REQUESTS}`,
                    method: 'POST',
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.text(),
                }),
                invalidatesTags: ['Reports'],
            }),
            getSplitScheduleReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                SplitScheduleReportExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getSplitScheduleReportExcelAsync: build.mutation<
                PostApiFmByFlidReportsRequestsApiResponse,
                SplitScheduleReportExcelApiAsyncArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.REQUESTS}`,
                    method: 'POST',
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.text(),
                }),
                invalidatesTags: ['Reports'],
            }),
            getVariableSplitScheduleReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                VariableSplitScheduleReportExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getVariableSplitScheduleReportExcelAsync: build.mutation<
                PostApiFmByFlidReportsRequestsApiResponse,
                VariableSplitScheduleReportExcelApiAsyncArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.REQUESTS}`,
                    method: 'POST',
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.text(),
                }),
                invalidatesTags: ['Reports'],
            }),
            getDriverDeliveryVarianceReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                DriverDeliveryVarianceReportExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getVetYardSheetReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                GetApiFmByFlidReportsExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getLoaderReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                LoaderReportExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getActualVersusExpectedFeedChargesReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                ActualVersusExpectedFeedChargesExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getActualVersusExpectedFeedChargesReportExcelAsync: build.mutation<
                PostApiFmByFlidReportsRequestsApiResponse,
                ActualVersusExpectedFeedChargesExcelApiAsyncArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.REQUESTS}`,
                    method: 'POST',
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.text(),
                }),
                invalidatesTags: ['Reports'],
            }),
            getCommodityPricingReportExcelAsync: build.mutation<
                PostApiFmByFlidReportsRequestsApiResponse,
                CommodityPricingReportExcelApiAsyncArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.REQUESTS}`,
                    method: 'POST',
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.text(),
                }),
                invalidatesTags: ['Reports'],
            }),
            getCommodityHistoryReportExcelAsync: build.mutation<
                PostApiFmByFlidReportsRequestsApiResponse,
                CommodityHistoryReportExcelApiAsyncArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.REQUESTS}`,
                    method: 'POST',
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.text(),
                }),
                invalidatesTags: ['Reports'],
            }),
            getVetYardSheetReportExcelAsync: build.mutation<
                PostApiFmByFlidReportsRequestsApiResponse,
                VetYardSheetReportExcelApiAsyncArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.REQUESTS}`,
                    method: 'POST',
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.text(),
                }),
                invalidatesTags: ['Reports'],
            }),
            getYardSheetReportExcelAsync: build.mutation<
                PostApiFmByFlidReportsRequestsApiResponse,
                YardSheetReportExcelApiAsyncArgExtended
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.REQUESTS}`,
                    method: 'POST',
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.text(),
                }),
                invalidatesTags: ['Reports'],
            }),
            getFeedByLotReportExcelAsync: build.mutation<
                PostApiFmByFlidReportsRequestsApiResponse,
                FeedByLotExcelApiAsyncArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.REQUESTS}`,
                    method: 'POST',
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.text(),
                }),
                invalidatesTags: ['Reports'],
            }),
            getMedicalInventoryReportExcelAsync: build.mutation<
                PostApiFmByFlidReportsRequestsApiResponse,
                MedicalInventoryReportExcelApiAsyncArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.REQUESTS}`,
                    method: 'POST',
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.text(),
                }),
                invalidatesTags: ['Reports'],
            }),
            getLoadedCommodityVarianceReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                LoadedCommodityVarianceReportExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getExportScaleTicketsReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                ExportScaleTicketsExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getTreatmentReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                GetTreatmentReportExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getInvoiceSummaryByDateRangeExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                GetInvoiceSummaryByDateRangeExcelArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getCommodityBillingExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                GetCommodityBillingExcelArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        include: queryArg.include ?? '',
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getDailyChargesExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                GetDailyChargesExcelArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getMovementHistoryExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                GetMovementHistoryExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getGenericReportExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                GetApiFmByFlidReportsExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.EXCEL}`,
                    params: {
                        ...queryArg,
                    },
                    responseHandler: response => response.blob(),
                }),
                providesTags: ['Reports'],
            }),
            getApiFmByDashboardCattleHeadCount: build.query<
                GetApiFmByFlidReportsDashboardCattleHeadCountResponse[],
                GetApiFmByFlidReportsJsonApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.JSON}`,
                    params: {
                        ...queryArg,
                    },
                }),
                providesTags: ['Reports'],
                keepUnusedDataFor: 86400,
            }),
            getApiFmByDashboardCattleOwners: build.query<
                GetApiFmByFlidReportsDashboardCattleOwnersResponse[],
                GetApiFmByFlidReportsJsonApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.JSON}`,
                    params: {
                        ...queryArg,
                    },
                }),
                providesTags: ['Reports'],
                keepUnusedDataFor: 86400,
            }),
            getApiFmByDashboardFeedingEvent: build.query<
                GetApiFmByFlidReportsDashboardFeedingResponse[],
                GetApiFmByFlidReportsJsonApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.JSON}`,
                    params: {
                        ...queryArg,
                    },
                }),
                providesTags: ['Reports'],
                keepUnusedDataFor: 86400,
            }),
            getApiFmByDashboardFeedingStatus: build.query<
                GetApiFmByFlidReportsDashboardFeedingStatusResponse[],
                GetApiFmByFlidReportsJsonApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.JSON}`,
                    params: {
                        ...queryArg,
                    },
                }),
                providesTags: ['Reports'],
                keepUnusedDataFor: 86400,
            }),
            getApiFmByDashboardFeedingTotalMfe: build.query<
                GetApiFmByFlidReportsDashboardFeedingTotalMfeResponse[],
                GetApiFmByFlidReportsJsonApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.JSON}`,
                    params: {
                        ...queryArg,
                    },
                }),
                providesTags: ['Reports'],
                keepUnusedDataFor: 86400,
            }),
            getApiFmByDashboardMovementHealth: build.query<
                GetApiFmByFlidReportsDashboardMovementHealthResponse[],
                GetApiFmByFlidReportsJsonApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.JSON}`,
                    params: {
                        ...queryArg,
                    },
                }),
                providesTags: ['Reports'],
                keepUnusedDataFor: 86400,
            }),
            getApiFmByDashboardMovementHealthv2: build.query<
                GetApiFmByFlidReportsDashboardMovementHealthResponsev2[],
                GetApiFmByFlidReportsJsonApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.JSON}`,
                    params: {
                        ...queryArg,
                    },
                }),
                providesTags: ['Reports'],
                keepUnusedDataFor: 86400,
            }),
            getApiFmByDashboardOutOfSyncFeedcalls: build.query<
                GetApiFmByFlidReportsDashboardFeedcallOutOfSyncResponse[],
                GetApiFmByFlidReportsJsonApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.JSON}`,
                    params: {
                        ...queryArg,
                    },
                }),
                providesTags: ['Reports'],
                keepUnusedDataFor: 86400,
            }),
            getApiFmByFlidReportsAndToken: build.query<
                GetApiFmByFlidReportsAndTokenApiResponse,
                GetApiFmByFlidReportsAndTokenApiArg
            >({
                query: queryArg => ({
                    url: `/api/fm/${queryArg.flid}/reports/${queryArg.token}`,
                    responseHandler: response => response.blob(),
                }),
            }),
            getApiFmByFlidReportsFeedlotMovementsAndHdCounts: build.query<
                getApiFmByFlidReportsFeedlotFeedlotMovementsAndHdCountsApiResponse[],
                getApiFmByFlidReportsFeedlotFeedlotMovementsAndHdCountsApiArg
            >({
                query: queryArg => ({
                    url: `/api${Constants.apiUrls.FEED_LOT_MANAGER}/${queryArg.flid}${Constants.apiUrls.REPORTS}${Constants.apiUrls.JSON}`,
                    params: {
                        reportName: ReportName.FeedlotMovementsAndHdCounts,
                        startDate: queryArg.startDate,
                        penId: queryArg.penId,
                    },
                }),
                keepUnusedDataFor: 10,
                providesTags: ['Reports'],
            }),
        }),
        overrideExisting: true,
    })
    .enhanceEndpoints({
        addTagTypes: [],
        endpoints: {},
    });

export interface GetCommodityUsageReportExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
}
export interface GetCommodityHistoryReportExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
}

export interface CommodityHistoryReportExcelApiAsyncArg
    extends PostApiFmByFlidReportsRequestsApiArg {
    startDate: string;
    endDate: string;
}

export interface GetMedicalInventoryReportExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
    medicalItemName?: string;
    medicalItemId?: number;
}

export interface MedicalInventoryReportExcelApiAsyncArg
    extends PostApiFmByFlidReportsRequestsApiArg {
    startDate: string;
    endDate: string;
    medicalItemName?: string;
    medicalItemId?: number;
}
export interface GetCommodityPricingReportExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
}

export interface CommodityPricingReportExcelApiAsyncArg
    extends PostApiFmByFlidReportsRequestsApiArg {
    startDate: string;
    endDate: string;
}

export type VetYardSheetReportExcelApiAsyncArg =
    PostApiFmByFlidReportsRequestsApiArg;

export type YardSheetReportExcelApiAsyncArg =
    PostApiFmByFlidReportsRequestsApiArg;

export interface YardSheetReportExcelApiAsyncArgExtended
    extends YardSheetReportExcelApiAsyncArg {
    ownerId?: number | string;
}
export interface GetMedicalPricingReportExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
    medicalItemId?: number;
    category?: string;
    subCategory?: string;
    onlyActive?: boolean;
}

export interface EidLotReportExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    lotId: number;
    lotName: string;
}

export interface ReceiveReportExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
    owner: string;
    lot: string;
    origin: string;
}

export interface ShipCattleReportExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate?: string;
    endDate?: string;
    lotName?: string;
    lotId?: number;
    owner?: string;
    destination?: string;
}
export interface AsFedReportExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate?: string;
    endDate?: string;
    numberOfDays?: number;
}

export interface FeedByLotExcelApiArg extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
    lotId?: number;
    ownerId?: number;
}

export interface FeedByLotExcelApiAsyncArg
    extends PostApiFmByFlidReportsRequestsApiArg {
    startDate: string;
    endDate: string;
}

export interface PenRiderExcelApiArg extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
    riderId?: number;
}
export interface FeedOutOfVarianceExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
}

export interface MoveToCattleExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    date: string;
}

export interface FeedOutOfVarianceExcelApiAsyncArg
    extends PostApiFmByFlidReportsRequestsApiArg {
    startDate: string;
    endDate: string;
}

export interface SplitScheduleReportExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
}

export interface SplitScheduleReportExcelApiAsyncArg
    extends PostApiFmByFlidReportsRequestsApiArg {
    startDate: string;
    endDate: string;
}

export interface VariableSplitScheduleReportExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
}

export interface VariableSplitScheduleReportExcelApiAsyncArg
    extends PostApiFmByFlidReportsRequestsApiArg {
    startDate: string;
    endDate: string;
}

export interface LoaderReportExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
}

export interface DriverDeliveryVarianceReportExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
}

export interface ActualVersusExpectedFeedChargesExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
}

export interface ActualVersusExpectedFeedChargesExcelApiAsyncArg
    extends PostApiFmByFlidReportsRequestsApiArg {
    startDate: string;
    endDate: string;
}

export interface LoadedCommodityVarianceReportExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    date?: string;
}

export interface LoadedCommodityVarianceReportByDateRangeExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
}

export interface RealizerReportExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
    owner?: string;
    lotName?: string;
    destination?: string;
    reason?: string;
}

export interface ExportScaleTicketsExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
    vendorId: number;
}

export interface GetTreatmentReportExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
}

export interface GetInvoiceSummaryByDateRangeExcelArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
}

export interface GetCommodityBillingExcelArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
    include?: string;
}
export interface GetDailyChargesExcelArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate: string;
    endDate: string;
    filter: string;
    lotId?: number;
    penId?: number;
}

export interface GetMovementHistoryExcelApiArg
    extends GetApiFmByFlidReportsExcelApiArg {
    startDate?: string;
    endDate?: string;
}

export interface GetApiFmByFlidReportsDashboardCattleHeadCountResponse {
    hdCount: number | null;
    penKind: string;
}

export interface GetApiFmByFlidReportsDashboardCattleOwnersResponse {
    hdCount: number;
    mortalities: number;
    owner: string;
    ownerId: number;
    realizers: number;
    sold: number;
}

export interface GetApiFmByFlidReportsDashboardFeedingResponse {
    event: string;
    started: string | null;
    finished: string | null;
}

export interface GetApiFmByFlidReportsDashboardFeedingStatusResponse {
    penCount: number;
    pens: string | null;
    status: string;
}

export interface GetApiFmByFlidReportsDashboardFeedingTotalMfeResponse {
    totalMFE: number;
}

export interface GetApiFmByFlidReportsDashboardMovementHealthResponse {
    dataType: string;
    today: number;
    thisWeek: number;
    lastWeek: number;
}

export interface GetApiFmByFlidReportsDashboardMovementHealthResponsev2 {
    dataType: string;
    lastWeek_RecordCount: number;
    lastWeek_TotalHdCount: number;
    thisWeek_RecordCount: number;
    thisWeek_TotalHdCount: number;
    today_RecordCount: number;
    today_TotalHdCount: number;
}

export interface GetApiFmByFlidReportsDashboardFeedcallOutOfSyncResponse {
    fcPenId: number | null;
    penId: number | null;
    fcName: string | null;
    name: string | null;
    fcHdCount: number | null;
    penHdCount: number | null;
}

export interface getApiFmByFlidReportsFeedlotFeedlotMovementsAndHdCountsApiResponse {
    actionType: string;
    createdBy: string;
    date: string;
    hdCount: number;
    lotHdCount: number;
    lotId: number;
    lotName: string;
    penHdCount: number;
    penId: number;
    penName: string;
    refPens: string | null;
    sublotHdCount: number;
    timestamp: string;
}

export interface getApiFmByFlidReportsFeedlotFeedlotMovementsAndHdCountsApiArg {
    flid: number;
    startDate: string;
    penId: number;
}
